<div class="coordinates-display">
  <table class="coordinates-table">
    <tr class="ra-dec">
      <td [innerHTML]="ra" class="ra"></td>
      <td [innerHTML]="dec" class="dec"></td>
    </tr>
    <tr *ngIf="showGalactic" class="galactic">
      <td [innerHTML]="galacticRa" class="gal-ra"></td>
      <td [innerHTML]="galacticDec" class="gal-dec"></td>
    </tr>
  </table>

  <div *ngIf="showAttribution" class="pixinsight-attribution">
    {{ "Powered by" | translate }}
    <a class="no-external-link" astrobinEventStopPropagation href="https://pixinsight.com/" target="_blank"
      >PixInsight</a
    >
  </div>
</div>
